const shapes = [
  {
    name: "Large Charger",
    dimensions: "35cm",
    image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_charger.jpg?v=1727953012",
    packSize: 2,
    wholesalePrice1: 58,
    wholesalePrice2: 70,
    wholesalePrice3: 77,
    wholesalePrice4: 98,
    wholesalePrice5: 118,
    wholesalePrice6: 170,
    retailPrice1: 145,
    retailPrice2: 175,
    retailPrice3: 192.5,
    retailPrice4: 245,
    retailPrice5: 295,
    retailPrice6: 425,
  },
  {
    name: "Small Charger",
    dimensions: "32cm",
    image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_charger-small.jpg?v=1727953013",
    packSize: 2,
    wholesalePrice1: 35,
    wholesalePrice2: 43,
    wholesalePrice3: 48,
    wholesalePrice4: 60,
    wholesalePrice5: 73,
    wholesalePrice6: 100,
    retailPrice1: 87.5,
    retailPrice2: 107.5,
    retailPrice3: 120,
    retailPrice4: 150,
    retailPrice5: 185.5,
    retailPrice6: 250,
  },
  {
    name: "Dinner Plate",
    dimensions: "27cm",
    image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_dinner-plate.jpg?v=1727953012",
    packSize: 4,
    wholesalePrice1: 48,
    wholesalePrice2: 60,
    wholesalePrice3: 21.4,
    wholesalePrice4: 22.7,
    wholesalePrice5: 24.2,
    wholesalePrice6: 30.7,
    retailPrice1: 120,
    retailPrice2: 150,
    retailPrice3: 53.5,
    retailPrice4: 56.75,
    retailPrice5: 60.5,
    retailPrice6: 76.75,
  },
  {
    name: "Side Plate",
    dimensions: "21cm",
    image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_side-plate.jpg?v=1727953012",
    packSize: 4,
    wholesalePrice1: 32,
    wholesalePrice2: 36,
    wholesalePrice3: 13.75,
    wholesalePrice4: 15.1,
    wholesalePrice5: 17.55,
    wholesalePrice6: 21.2,
    retailPrice1: 80,
    retailPrice2: 90,
    retailPrice3: 34.38,
    retailPrice4: 37.75,
    retailPrice5: 43.88,
    retailPrice6: 53,
  },
  {
    name: "Pasta Plate",
    dimensions: "25cm",
    image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_pasta.jpg?v=1727953012",
    packSize: 2,
    wholesalePrice1: 36,
    wholesalePrice2: 44,
    wholesalePrice3: 27.6,
    wholesalePrice4: 30.8,
    wholesalePrice5: 42.5,
    wholesalePrice6: 47.2,
    retailPrice1: 90,
    retailPrice2: 110,
    retailPrice3: 69,
    retailPrice4: 77,
    retailPrice5: 106.25,
    retailPrice6: 118,
  },
  {
    name: "Soup Bowl",
    dimensions: "14cm",
    image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_soup.jpg?v=1727953011",
    packSize: 4,
    wholesalePrice1: 44,
    wholesalePrice2: 44,
    wholesalePrice3: 44,
    wholesalePrice4: 44,
    wholesalePrice5: 0,
    wholesalePrice6: 0,
    retailPrice1: 110,
    retailPrice2: 110,
    retailPrice3: 110,
    retailPrice4: 110,
    retailPrice5: 0,
    retailPrice6: 0,
  },
  {
    name: "Tapas Bowl",
    dimensions: "12cm",
    image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_tapas.jpg?v=1727953012",
    packSize: 4,
    wholesalePrice1: 34,
    wholesalePrice2: 34,
    wholesalePrice3: 34,
    wholesalePrice4: 34,
    wholesalePrice5: 0,
    wholesalePrice6: 0,
    retailPrice1: 85,
    retailPrice2: 85,
    retailPrice3: 85,
    retailPrice4: 85,
    retailPrice5: 0,
    retailPrice6: 0,
  },
  {
    name: "Salad Bowl",
    dimensions: "25cm",
    image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_salad.jpg?v=1727953012",
    packSize: 1,
    wholesalePrice1: 28,
    wholesalePrice2: 28,
    wholesalePrice3: 28,
    wholesalePrice4: 28,
    wholesalePrice5: 0,
    wholesalePrice6: 0,
    retailPrice1: 70,
    retailPrice2: 70,
    retailPrice3: 70,
    retailPrice4: 70,
    retailPrice5: 0,
    retailPrice6: 0,
  },
  {
    name: "Large Tray",
    dimensions: "26x33cm",
    image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_tray-large.jpg?v=1727953012",
    packSize: 2,
    wholesalePrice1: 42,
    wholesalePrice2: 62.2,
    wholesalePrice3: 69,
    wholesalePrice4: 88,
    wholesalePrice5: 106,
    wholesalePrice6: 160,
    retailPrice1: 105,
    retailPrice2: 155.5,
    retailPrice3: 172.5,
    retailPrice4: 220,
    retailPrice5: 265,
    retailPrice6: 400,
  },
  {
    name: "Small Tray",
    dimensions: "15x21cm",
    image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_tray-small.jpg?v=1727953012",
    packSize: 2,
    wholesalePrice1: 22,
    wholesalePrice2: 31.6,
    wholesalePrice3: 34.5,
    wholesalePrice4: 44,
    wholesalePrice5: 53,
    wholesalePrice6: 80,
    retailPrice1: 55,
    retailPrice2: 79,
    retailPrice3: 86.25,
    retailPrice4: 110,
    retailPrice5: 132.5,
    retailPrice6: 200,
  },
];

const designs = [
  { name: "Cascos", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_V_CASCOS.png?v=1727952502", priceKey: 1 },
  { name: "Helecho", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_V_HELECHO.png?v=1727952503", priceKey: 2 },
  { name: "Carmen Flor Light", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_V_FLOR_DEL_CARMEN.png?v=1727952503", priceKey: 2 },
  { name: "Franjas", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_V_FRANJAS.png?v=1727952502", priceKey: 3 },
  { name: "Ondas", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_V_ONDAS.png?v=1727952502", priceKey: 4 },
  { name: "Helecho Dark", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_V_DARK_HELECHO.png?v=1727952503", priceKey: 6 },
  { name: "Carmen Flor Dark", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_V_DARK_FLOR_DEL_CARMEN.png?v=1727952503", priceKey: 6 },
  { name: "Flor Dark", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_V_DARK_FLOR.png?v=1727952502", priceKey: 6 },
];

const colours = [
  { name: "Burnet Yellow", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_burnet.jpg?v=1727952843" },
  { name: "Golden Yellow", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_golden.jpg?v=1727952844" },
  { name: "Uchua Yellow", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_uchua.jpg?v=1727952844" },
  { name: "Cinnamon", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_cinnamon.jpg?v=1727952843" },
  { name: "Rust Red", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_rust.jpg?v=1727952842" },
  { name: "Peoni", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_peoni.jpg?v=1727952843" },
  { name: "Leaf Green", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_leaf.jpg?v=1727952843" },
  { name: "Fern Green", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_fern.jpg?v=1727952844" },
  { name: "Petroleum", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_petroleum.jpg?v=1727952843" },
  { name: "Ocean Blue", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_ocean.jpg?v=1727952843" },
  { name: "Cobalt Blue", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_cobalt.jpg?v=1727952843" },
  { name: "Jet Black", image: "https://cdn.shopify.com/s/files/1/0828/6896/1546/files/order-form_jet.jpg?v=1727952842" },
];
